var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"devise-page"},[_c('iframe',{ref:"iframe",staticClass:"iframe-box",attrs:{"title":"可视化编辑容器","id":"iframe","src":_vm.iframeUrl,"frameborder":"0"}}),_c('div',{staticClass:"content"},[_c('right-config',{attrs:{"index":_vm.index}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }